export function formatTrackingValue<T>(value: T): string {
	if (Array.isArray(value)) {
		return value.join('|');
	}
	if (typeof value === 'number' || typeof value === 'boolean') {
		return value.toString();
	}
	return value as string;
}
